module.exports = __webpack_public_path__ + "img/web os 55.337363eb.jpg";